import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { SiteCodes } from '../entities/global/model';
import { SafetyConfigService } from '../services/safety-config.service';
//import { Console } from 'console';
import { SafetyGeneraldashboardService } from '../services/safety-generaldashboard.service';

const dataSourceforgraph= {
  chart: {
    theme: "fusion",
   // "caption": "Number of visitors last week",
   // "subCaption": "Bakersfield Central vs Los Angeles Topanga",
    xAxisName: "Month",
    //"yaxisminvalue": "0",
   // "showvalues": "0",
    yaxisname: "Value",
    legenditemfontsize: "15",
   
    yAxisMinValue: 0,
    showvalues: "0",
    minimizeTendency: 1,
   
    legenditemfontbold: "1",
   
    

    
  },
  categories: [{
    category: [{
        label: "0"
      },
      {
        label: "0"
      },
      {
        label: "0"
      },
      {
        label: "0"
      },
      {
        label: "0"
      },
      {
        label: "0"
      },
      {
        label: "0"
      },
      {
        label: "0"
      },
      {
        label: "0"
      },
      {
        label: "0"
      },
      {
        label: "0"
      },
      {
        label: "0"
      },
      {
        label: "0"
      }
    ]
  }],
  dataset: [{
    //red list
      seriesname: "TRIFR Reportable Incidents per 1,000,000 hours worked",
      color: "#E57878",
      data: [{
        value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        }
      ]
    },
    {
      seriesname: "SCFR - Safety Observations per 100 hours worked",
      color: "#90DE8C",
      //green ist
      data: [{
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        }
      ]
    },
    {
      seriesname: "Recordable Incidents",
      color: "#68A3E5",
      //blue ist
      data: [{
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        }


      ]
    },
    {
      seriesname: "HRFR - Safety Observations with Fails per 100 hours worked",
      color: "#8C8EDE",
      //purple ist
      data: [{
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        },
        {
          value: "0"
        }
      ]
    }
  ]
  
}
@Component({
  selector: 'app-safety-indicators',
  templateUrl: './safety-indicators.component.html',
  styleUrls: ['./safety-indicators.component.css']
})
export class SafetyIndicatorsComponent implements OnInit {
  width = 1124;
  height = 562;
  type = "msspline";
  dataFormat = "json";
  dataSource = dataSourceforgraph;
  currentMonth
  previousYear
  stateID:number=0
  siteCodesList: SiteCodes[]=[];
  constructor(private _safetyGeneraldashboardService: SafetyGeneraldashboardService,
    private _safetyConfigService:SafetyConfigService,) { 
   
   
  }

  ngOnInit() {
    this.GetObservationQuestionMonthlyhours();
    this.GetTRIFRForLast12Months();
    this.GetTRIFRIncidentsForLast12Months();
    this.GetHRFRForLast12Months();
    this.showCurrentYear();
    this.loadSiteList();


 

var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

var today = new Date();
var d_;
var month_;

for(var i = 12; i >= 0; i -= 1) {
  d_ = new Date(today.getFullYear(), today.getMonth() - i, 1);
  month_ = monthNames[d_.getMonth()];
  console.log("month", month_);
  dataSourceforgraph.categories[0].category[(12-i)].label=month_
}
           
           
  }

  loadSiteList()
 {
   this._safetyConfigService.getAllSitesList().subscribe(sites =>
   { 
     console.log('sitelist',sites)
     this.siteCodesList=sites;
     
   });
 }
 state = new FormControl("", [Validators.required]);
  getErrorMessage() {
    return this.state.hasError("required") ? "You must enter a value" : "";
  }

  showCurrentYear()
  {
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
            var date = new Date();
            this.currentMonth= months[date.getMonth()] + ' ' + date.getFullYear();
            this.previousYear = months[date.getMonth()] + ' ' +( date.getFullYear()-1);
  }

  GetTRIFRForLast12Months()
  { console.log(this.stateID)
    this._safetyGeneraldashboardService.GetTRIFRForLast12Months(this.stateID).subscribe(res=>{
      console.log('red List',res)
      for(var i = 0; i < 13; i++)
      {
        dataSourceforgraph.dataset[0].data[i]={"value": res.m_Item2[i]}
        
      }
      
    })
  }

  GetObservationQuestionMonthlyhours()
  {
    this._safetyGeneraldashboardService.GetObservationQuestionMonthlyhours(this.stateID).subscribe(res=>{
      console.log('Green List',res)
      for(var i = 0; i < 13; i++)
      {
        dataSourceforgraph.dataset[1].data[i]={"value": res.m_Item2[i]}
        
      }
    })
  }

  GetTRIFRIncidentsForLast12Months()
  {
    this._safetyGeneraldashboardService.GetTRIFRIncidentsForLast12Months(this.stateID).subscribe(res=>{
      console.log('Blue List',res)
      for(var i = 0; i < 13; i++)
      {
        dataSourceforgraph.dataset[2].data[i]={"value": res.m_Item2[i]}
        
      }
    })
  }

  GetHRFRForLast12Months()
  {
    this._safetyGeneraldashboardService.GetHRFRForLast12Months(this.stateID).subscribe(res=>{
      console.log('Purple List',res)
      for(var i = 0; i < 13; i++)
      {
        dataSourceforgraph.dataset[3].data[i]={"value": res.m_Item2[i]}
        
      }
    })
  }

}
